// Implements: F-UIX-019, F-RPT-006
/**
 * Mockup v3 P9: how "Latencia y errores por modelo y paso" writes its numbers (v3 `:1916-1919`).
 * Pure. Durations are seconds with one decimal and a comma ("4,2" for 4200 ms), the rate a
 * percentage with one decimal and a comma ("3,0" for 0.03), as the mockup writes them whatever the
 * platform's number locale. A rate AT or above the 3 % objective is flagged (`>=`, v3 `rate >= 3`).
 */

/** The error rate the platform aims to stay under. */
export const RATE_OBJECTIVE = 0.03;

function oneDecimal(value: number): string {
  return value.toFixed(1).replace(".", ",");
}

export function secondsText(ms: number): string {
  return oneDecimal(ms / 1000);
}

export function rateText(rate: number): string {
  return oneDecimal(rate * 100);
}

export function isAboveObjective(rate: number): boolean {
  return rate >= RATE_OBJECTIVE;
}
